import { jsx as _jsx } from "react/jsx-runtime";
import { IconContainer, SvgIconSpined } from './SnackbarIcon.styled';
import arrowsRotateIcon from '@/core/svg/fa/arrows-rotate.svg';
import circleCheckIcon from '@/core/svg/fa/circle-check.svg';
import circleInfoIcon from '@/core/svg/fa/circle-info.svg';
import circleXmarkIcon from '@/core/svg/fa/circle-xmark.svg';
import inboxInIcon from '@/core/svg/fa/inbox-in.svg';
import lockIcon from '@/core/svg/fa/lock.svg';
import triangleExclamationIcon from '@/core/svg/fa/triangle-exclamation.svg';
import { useTheme } from '@mui/material';
import { isSnackbarBaseVariant } from './isSnackbarBaseVariant';
export const SnackbarIcon = ({ variant, icon: customIcon }) => {
    const { palette } = useTheme();
    const size = variant === 'receiptSubmissionSuccess' || variant === 'receiptBlockSuccess'
        ? '1.75rem'
        : variant === 'receiptSubmissionError'
            ? '2rem'
            : '4xl';
    const icon = customIcon
        ? customIcon
        : variant === 'receiptSubmissionSuccess'
            ? inboxInIcon
            : variant === 'receiptBlockSuccess'
                ? lockIcon
                : variant === 'success'
                    ? circleCheckIcon
                    : variant === 'warning'
                        ? triangleExclamationIcon
                        : variant === 'error' || variant === 'receiptSubmissionError'
                            ? circleXmarkIcon
                            : variant === 'info'
                                ? circleInfoIcon
                                : variant === 'reconnect'
                                    ? arrowsRotateIcon
                                    : circleInfoIcon;
    const color = variant === 'success' || variant === 'receiptSubmissionSuccess'
        ? palette.success.main
        : variant === 'warning' || variant === 'receiptBlockSuccess'
            ? palette.warning.main
            : variant === 'error' || variant === 'receiptSubmissionError'
                ? palette.error.dark
                : variant === 'info'
                    ? palette.info.main
                    : variant === 'reconnect'
                        ? palette.primary.main
                        : palette.info.main;
    return (_jsx(IconContainer, { size: isSnackbarBaseVariant(variant) ? 'defaultSnackbarIconSize' : 'receiptSnackbarIconSize', children: _jsx(SvgIconSpined, { size: size, icon: icon, color: color, spin: variant === 'reconnect' }) }));
};
